import { render, staticRenderFns } from "./PerfilView.vue?vue&type=template&id=363b544c&scoped=true"
import script from "./PerfilView.vue?vue&type=script&lang=js"
export * from "./PerfilView.vue?vue&type=script&lang=js"
import style0 from "./PerfilView.vue?vue&type=style&index=0&id=363b544c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b544c",
  null
  
)

export default component.exports